import React, { useState } from "react";

import html2pdf from "html2pdf.js";

import { FaFilePdf } from "react-icons/fa";



const ReportDownload = ({ users, title, filters = {} }) => {

  const [isGenerating, setIsGenerating] = useState(false);



  // Pagination Logic: Page 1 (4 records), Others (5 records)

  const getPages = (data) => {

    if (!data || data.length === 0) return [];

    const pages = [];

    pages.push(data.slice(0, 4));

    const remaining = data.slice(4);

    for (let i = 0; i < remaining.length; i += 5) {

      pages.push(remaining.slice(i, i + 5));

    }

    return pages;

  };



  const handleDownload = async () => {

    if (users.length === 0) return;

    setIsGenerating(true);



    const element = document.getElementById("report-print-container");

    const options = {

      margin: 0, // Margin is handled internally by our padding

      filename: `${(title || "Membership_Report").replace(/\s+/g, "_")}.pdf`,

      image: { type: "jpeg", quality: 0.98 },

      html2canvas: { scale: 2, useCORS: true, logging: false },

      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },

      // Changed to 'avoid-all' to stop double-breaking

      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }

    };



    try {

      await html2pdf().set(options).from(element).save();

    } catch (error) {

      console.error("Report generation failed", error);

    } finally {

      setIsGenerating(false);

    }

  };



  const userPages = getPages(users);

  const now = new Date();

 

  const displayState = filters.state && filters.state !== "All States" ? filters.state : (users[0]?.state || "N/A");

  const displayLga = filters.lga && filters.lga !== "All LGAs" ? filters.lga : (users[0]?.lga || "N/A");

  const displayWard = filters.ward && filters.ward !== "All Wards" ? filters.ward : (users[0]?.ward || "N/A");

  const displayPu = filters.pollingUnit && filters.pollingUnit !== "All Polling Units" ? filters.pollingUnit : (users[0]?.pollingUnit || "N/A");



  return (

    <>

      <button

        className="btn btn-outline-danger w-100 btn-sm fw-bold py-2 shadow-sm d-flex align-items-center justify-content-center gap-2 mt-2"

        onClick={handleDownload}

        disabled={isGenerating || users.length === 0}

      >

        {isGenerating ? <span className="spinner-border spinner-border-sm" /> : <FaFilePdf />}

        {isGenerating ? "Generating Report..." : `Download PDF Report`}

      </button>



      {/* Hidden PDF Container */}

      <div style={{ position: "absolute", left: "-9999px", top: 0 }}>

        <div id="report-print-container" style={{ width: "210mm", backgroundColor: "#fff", fontFamily: "Arial, sans-serif" }}>

         

          {userPages.map((chunk, pageIndex) => (

            <div key={pageIndex} style={{

              height: "296mm", // Standard A4 height

              pageBreakAfter: "always",

              padding: "12mm",

              boxSizing: "border-box",

              display: "flex",

              flexDirection: "column"

            }}>

             

              {/* PAGE 1 HEADER */}

{pageIndex === 0 ? (

  <>

    <div style={{

      textAlign: "center",

      marginBottom: "8px",

      WebkitPrintColorAdjust: "exact", // Forces background colors to show

      printColorAdjust: "exact"

    }}>

      <img src="/logo2.jpeg" alt="LP Logo" style={{ width: "25mm", height: "auto", marginBottom: "4px" }} />

      <h2 style={{ margin: "0", color: "#000", fontWeight: "bold", fontSize: "20px" }}>Labour Party (LP)</h2>

     

      {/* MOTTO SECTION - Improved for PDF Rendering */}

      <div style={{

        backgroundColor: "#f1f8f1",

        display: "block", // Changed to block with a max-width for stability

        margin: "5px auto",

        width: "fit-content",

        padding: "5px 20px",

        borderRadius: "20px",

        border: "1px solid #c8e6c9",

        WebkitPrintColorAdjust: "exact"

      }}>

        <h5 style={{

          margin: "0",

          color: "#088d01",

          fontWeight: "bold",

          fontStyle: "italic",

          fontSize: "12px",

          display: "block" // Ensure text is treated as a block

        }}>

          Motto: Equal Opportunity and Social Justice

        </h5>

      </div>

    </div>

                  {/* VERTICALLY ALIGNED LOCATION DETAILS */}

                  <div style={{

                    display: "flex",

                    justifyContent: "space-between",

                    marginBottom: "15px",

                    fontSize: "11px",

                    borderTop: "2px solid #088d01",

                    paddingTop: "8px"

                  }}>

                    <div style={{ lineHeight: "1.6" }}>

                      <div><strong>STATE:</strong> {displayState}</div>

                      <div><strong>LGA:</strong> {displayLga}</div>

                      <div><strong>WARD:</strong> {displayWard}</div>

                      <div><strong>POLLING UNIT:</strong> {displayPu}</div>

                    </div>

                    <div style={{ textAlign: "right", lineHeight: "1.6" }}>

                      <div><strong>DATE PRINTED:</strong> {now.toLocaleDateString()}</div>

                      <div><strong>TIME:</strong> {now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</div>

                      <div><strong>TOTAL RECORDS:</strong> {users.length}</div>

                    </div>

                  </div>

                </>

              ) : (

                /* COMPACT CONTINUATION HEADER */

                <div style={{ display: "flex", justifyContent: "space-between", fontSize: "10px", borderBottom: "1px solid #088d01", paddingBottom: "5px", marginBottom: "12px", color: "#555" }}>

                  <span style={{fontWeight: "bold"}}>Labour Party Official Directory (Continued) - {displayLga}|{displayWard}|{displayPu}</span>

                  <span>Page {pageIndex + 1}</span>

                </div>

              )}



              {/* RECORD LIST */}

              <div style={{ flexGrow: 1 }}>

                {chunk.map((user, i) => (

                  <div key={i} style={{

                    display: "flex",

                    borderBottom: "1px solid #eee",

                    padding: "10px 0",

                    alignItems: "center"

                  }}>

                    <div style={{ width: "38mm", paddingRight: "15px" }}>

                      <img

                        src={user.passportUrl || "/default-avatar.png"}

                        alt="User"

                        style={{ width: "35mm", height: "35mm", objectFit: "cover", borderRadius: "4px", border: "1px solid #ddd" }}

                        crossOrigin="anonymous"

                      />

                    </div>



                    <div style={{ flex: 1, display: "grid", gridTemplateColumns: "1.2fr 1fr 1fr", gap: "4px 12px", fontSize: "12px" }}>

                      <div style={{ gridColumn: "span 3", borderBottom: "1px solid #f9f9f9", marginBottom: "4px" }}>

                        <strong style={{ fontSize: "17px", color: "#088d01" }}>{`${user.firstName} ${user.middleName || ''} ${user.lastName}`}</strong>

                        <span style={{ float: "right", color: "#d32f2f", fontWeight: "bold", fontSize: "13px" }}>LP/{user.regID}</span>

                      </div>

                      <div><strong>NIN:</strong> {user.nationalId}</div>

                      <div><strong>Voter's Card:</strong> {user.votersCardNo || "N/A"}</div>

                      <div><strong>Phone:</strong> {user.phoneNumber}</div>

                      <div><strong>Gender:</strong> {user.gender}</div>

                      <div><strong>DOB:</strong> {user.dob ? new Date(user.dob).toLocaleDateString() : "N/A"}</div>

                      <div><strong>Occupation:</strong> {user.occupation}</div>

                      <div style={{ gridColumn: "span 3", fontSize: "11px", color: "#555", marginTop: "3px" }}>

                        <strong>Address:</strong> {user.residentialAddress}

                      </div>

                    </div>

                  </div>

                ))}

              </div>



              {/* FOOTER */}

              <div style={{ textAlign: "center", padding: "10px 0", fontSize: "10px", color: "#888", borderTop: "1px solid #eee" }}>

                Page {pageIndex + 1} of {userPages.length} — This is an official document of the Labour Party (LP)

              </div>

            </div>

          ))}

        </div>

      </div>

    </>

  );

};



export default ReportDownload;